import React from 'react';
import { Container, EmptyIcon, BackToCellText, Label } from './style';
import { useTranslation } from 'i18n';
import { useNotificationSideDrawerOperations } from 'components/canvas/hooks/use-notification-side-drawer-visibility';

export interface EmptyNotificationListProps {}

const defaultProps = {};

function EmptyNotificationList(props: EmptyNotificationListProps) {
  const { t } = useTranslation();

  const { hideNotificationSideDrawer } = useNotificationSideDrawerOperations();

  return (
    <Container>
      <EmptyIcon />
      <Label>{t('Notifications about your activity will show up here')}</Label>
      <BackToCellText onClick={hideNotificationSideDrawer}>
        {t('Back to Cell')}
      </BackToCellText>
    </Container>
  );
}

EmptyNotificationList.defaultProps = defaultProps;

export default EmptyNotificationList;
